import LemonError from '@src/service/common/LemonError';

/** Thrown when unknown API method is called. */
export default class UnknownApiMethodError extends LemonError {
  constructor(methodName: string, apiName: string, message?: string) {
    super(`Unknown API method '${methodName}' on '${apiName}' API! ${message != null ? ': ' + message : ''}`);
  }
}
